"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var React = require("react");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var components_1 = require("components");
var handleImage = function (props, uuid) {
    if (uuid !== null && uuid !== undefined) {
        var image = new Image();
        image.onload = function () {
            props.setDefaultImage("".concat(__APIBASEURL__, "api/customer/").concat(uuid, "/customer-image"));
        };
        image.src = "".concat(__APIBASEURL__, "api/customer/").concat(uuid, "/customer-image");
    }
};
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('element', 'setElement', undefined), (0, recompose_1.withState)('defaultImage', 'setDefaultImage', undefined), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        handleImage(this.props, this.props.uuid);
    },
    componentWillReceiveProps: function (nextProps) {
        if (this.props.uuid !== nextProps.uuid &&
            this.props.dataUrl === undefined) {
            handleImage(this.props, nextProps.uuid);
        }
    }
}), recompose_1.pure);
var fileOnChange = function (props) {
    return (0, sok_ui_1.handleDrop)({
        value: [],
        onChange: function (file) {
            if (file.length > 0) {
                var reader_1 = new FileReader();
                var ff_1 = file[0].file;
                reader_1.onload = function () {
                    ff_1 && reader_1.result && props.setFile(ff_1, reader_1.result.toString());
                };
                ff_1 && reader_1.readAsDataURL(ff_1);
            }
        }
    });
};
function getImage(props) {
    if (props.dataUrl)
        return "url(".concat(props.dataUrl, ")");
    else if (props.defaultImage)
        return "url(".concat(props.defaultImage, ")");
    return undefined;
}
function hasImage(props) {
    return props.dataUrl || props.defaultImage;
}
exports.default = enhance(function (props) { return (React.createElement("div", { className: 'customer-picture' },
    React.createElement("div", { className: 'image-container', style: { backgroundImage: getImage(props) } },
        !hasImage(props) && (React.createElement("span", { className: 'message', onClick: function () { return props.element && props.element.click(); } },
            React.createElement("span", null, (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/company')),
            React.createElement("span", null, (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/logo')))),
        props.dataUrl && props.removePicture && (React.createElement(components_1.TableRowIcon, { circle: true, icon: 'fa-times', className: 'remove-btn', onClick: props.removePicture }))),
    React.createElement("input", { type: 'file', accept: 'image/*', ref: function (e) { return props.setElement(e); }, onChange: fileOnChange(props) }),
    React.createElement(sok_ui_1.Button, { color: 'base-blue', text: (0, translation_1.getLocalization)('admin/customerManagement/createNewCustomer/customerInformation/selectCompanyLogo'), onClick: function () { return props.element && props.element.click(); } }))); });
